<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card">
                <Toast />
                <h5>{{ $t('menu.ticketsSettings') }}</h5>
                <div class="p-grid">
                    <div class="p-col-12 p-grid">
                        <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('sportsSettings.isActive') }} *</label>
                        <div class="p-col-12 p-md-4">
                            <InputSwitch v-model="settings.isActive" />
                        </div>
                    </div>
                    <div class="p-col-12 p-grid">
                        <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('sportsSettings.topOfferActive') }} </label>
                        <div class="p-col-12 p-md-4">
                            <InputSwitch v-model="settings.topOfferActive" />
                        </div>
                    </div>
                    <div class="p-col-12">
                        <p>{{ $t('sportsSettings.pendingEventsIntervals') }}</p>
                    </div>
                </div>
                <Fieldset :legend="$t('sportsSettings.pendingEventsIntervals')" :toggleable="true" :collapsed="true">
                    <div class="p-grid" v-for="(item, index) in settings.pendingEventsIntervals" :key="'item' + index">
                        <div class="p-col-12 p-grid">
                            <label class="p-col-1 p-xs-6 ">{{ $t('sportsSettings.minEvents') }} </label>
                            <div class="p-col-1 p-xs-6">
                                <InputText style="width: 100%" type="number" v-model.number="item.minEvents" />
                            </div>
                            <label class="p-col-1 p-xs-6 ">{{ $t('sportsSettings.maxEvents') }} </label>
                            <div class="p-col-1 p-xs-6 ">
                                <InputText style="width: 100%" type="number" v-model.number="item.maxEvents" />
                            </div>
                            <label class="p-col-1 p-xs-6 ">{{ $t('sportsSettings.winDivider') }} </label>
                            <div class="p-col-1 p-xs-6 ">
                                <InputText style="width: 100%" type="number" v-model.number="item.winDivider" />
                            </div>
                            <label class="p-col-1 p-xs-6 ">{{ $t('sportsSettings.minWinEvents') }} </label>
                            <div class="p-col-1 p-xs-6 ">
                                <InputText style="width: 100%" type="number" v-model.number="item.minWinEvents" />
                            </div>
                            <label class="p-col-1 p-xs-6 ">{{ $t('sportsSettings.allWinEvents') }} </label>
                            <div class="p-col-1 p-xs-6 ">
                                <InputSwitch v-model="item.allWinEvents" />
                            </div>
                            <div class="p-col-1 p-xs-6 ">
                                <Button @click="removeInterval(index)" :label="$t('buttons.remove')" class="p-button-text p-button-danger p-mr-2 p-mb-2" />
                            </div>
                        </div>
                    </div>
                    <div class="p-col-12 p-md-4">
                        <Button @click="addNewInterval()" :label="$t('buttons.addNewInterval')" class="p-button-text p-button-warning p-mr-2 p-mb-2" />
                    </div>
                </Fieldset>
                <div class="p-col-12 p-md-4">
                    <Button @click="updateTicketsSettings()" :label="$t('buttons.save')" class="p-button-raised p-button-success p-mr-2 p-mb-2" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { SportsSettingsApi } from '../../service/SportSettingsApi.js';
export default {
    data() {
        return {
            SportsSettingsApi: new SportsSettingsApi(),
            loading: true,
            crtRoute: 'ticketsSettings',
            settings: {},
            errorKeyCount: 0,
            showError: false,
            errorText: '',
        };
    },
    computed: {},
    mounted() {
        this.ticketsSettings();
    },
    watch: {},
    methods: {
        ticketsSettings() {
            this.SportsSettingsApi.getTicketsSettings()
                .then(response => {
                    this.settings = response.data;
                })
                .catch(error => {
                    this.checkForUnauthorizedError(error);
                    this.showToast('error', this.$t('alerts.generalError'));
                });
        },
        updateTicketsSettings() {
            this.SportsSettingsApi.updateTicketsSettings(this.settings)
                .then(() => {
                    this.showToast('success', this.$t('alerts.okAction'));
                })
                .catch(error => {
                    this.checkForUnauthorizedError(error);
                    this.showToast('error', this.$t('alerts.generalError'));
                });
        },
        addNewInterval() {
            var emptyInterval = {
                minEvents: 0,
                maxEvents: 0,
                winDivider: 1,
                minWinEvents: 0,
                allWinEvents: false,
            };
            this.settings.pendingEventsIntervals.push(emptyInterval);
        },
        removeInterval(index) {
            this.settings.pendingEventsIntervals.splice(index, 1);
        },
        showToast(toastSeverity, text) {
            this.$toast.add({ severity: toastSeverity, summary: '', detail: text, life: this.getToastLifeSeconds() });
        },
    },
};
</script>
